import script from "./HomeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=088401e1&lang=less&scoped=true"

import exportComponent from "/Users/wangwangao/Desktop/test项目/vue3-TS-vant-env/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-088401e1"]])

export default __exports__